'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/.0.17.1@axios/lib/cancel/isCancel.js
// module id = 405
// module chunks = 1